"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _debounce = _interopRequireDefault(require("@sd-utility/debounce"));
var _fuseUtils = require("@tvg/fuse-utils");
var _noScroll = _interopRequireDefault(require("no-scroll"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _drawerHeader = _interopRequireDefault(require("./drawer-header"));
var _styledDrawerDialogue = require("./styled-drawer-dialogue");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback,
  useEffect = _react["default"].useEffect,
  useMemo = _react["default"].useMemo,
  useState = _react["default"].useState,
  useRef = _react["default"].useRef;
var sidesEnum = Object.freeze({
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom'
});
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].string.isRequired,
  backCallback: _propTypes["default"].func,
  closeCallback: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  hasBackButton: _propTypes["default"].bool,
  promotionalArea: _propTypes["default"].node,
  onClose: _propTypes["default"].func,
  open: _propTypes["default"].bool,
  stickyDrawer: _propTypes["default"].shape({
    container: _propTypes["default"].shape({
      className: _propTypes["default"].string,
      dataTestId: _propTypes["default"].string,
      open: _propTypes["default"].bool,
      transition: _propTypes["default"].string,
      zIndex: _propTypes["default"].string
    }),
    button: _propTypes["default"].element
  }),
  slidePosition: _propTypes["default"].oneOf([sidesEnum.bottom, sidesEnum.top, sidesEnum.left, sidesEnum.right]),
  srLabelBackButton: _propTypes["default"].string,
  srLabelCloseButton: _propTypes["default"].string,
  zIndex: _propTypes["default"].string,
  componentId: _propTypes["default"].string
};
var defaultProps = {
  backCallback: function backCallback() {},
  closeCallback: function closeCallback() {},
  dataTestId: undefined,
  hasBackButton: false,
  promotionalArea: undefined,
  onClose: function onClose() {},
  open: false,
  stickyDrawer: {
    container: {
      className: 'fuse-drawer__sticky-drawer',
      dataTestId: 'fuse-drawer-sticky-drawer-data-testid',
      open: false,
      transition: '200ms',
      zIndex: '1'
    },
    button: /*#__PURE__*/_react["default"].createElement(_buttons.Button, null)
  },
  slidePosition: sidesEnum.right,
  srLabelBackButton: undefined,
  srLabelCloseButton: undefined,
  zIndex: '1',
  componentId: (0, _fuseUtils.namedUuid)('fuse-drawer-header')
};
var DrawerDialog = forwardRef(function (_ref, ref) {
  var _drawerContentRef$cur;
  var _backCallback = _ref.backCallback,
    children = _ref.children,
    _closeCallback = _ref.closeCallback,
    dataTestId = _ref.dataTestId,
    hasBackButton = _ref.hasBackButton,
    promotionalArea = _ref.promotionalArea,
    onClose = _ref.onClose,
    open = _ref.open,
    stickyDrawer = _ref.stickyDrawer,
    slidePosition = _ref.slidePosition,
    srLabelBackButton = _ref.srLabelBackButton,
    srLabelCloseButton = _ref.srLabelCloseButton,
    title = _ref.title,
    zIndex = _ref.zIndex;
  // States
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isScrolled = _useState2[0],
    setIsScrolled = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocusInside = _useState4[0],
    setIsFocusInside = _useState4[1];
  // Refs
  var drawerContentRef = useRef();
  // Ids
  var drawerHeadingId = useMemo(function () {
    return (0, _fuseUtils.namedUuid)('fuse-drawer-header');
  }, []);
  // StickyDrawer config
  var stickyDrawerProps = stickyDrawer.container;
  var isStickyDrawerOpen = stickyDrawerProps.open;
  // Others
  var stickyDrawerHeight = isStickyDrawerOpen ? drawerContentRef === null || drawerContentRef === void 0 || (_drawerContentRef$cur = drawerContentRef.current) === null || _drawerContentRef$cur === void 0 || (_drawerContentRef$cur = _drawerContentRef$cur.children[2]) === null || _drawerContentRef$cur === void 0 ? void 0 : _drawerContentRef$cur.offsetHeight : 0;
  // Event handlers
  var handleScroll = useCallback(function (e) {
    return (0, _debounce["default"])(function (container) {
      var scrollTop = container.scrollTop;
      var isCurrentlyScrolled = scrollTop > 0;
      setIsScrolled(isCurrentlyScrolled);
    }, 20)(e.currentTarget);
  }, [isScrolled]);

  // Focus on container only once
  var handleBlur = useCallback(function () {
    if (open && !isFocusInside) setIsFocusInside(true);
  }, [open, isFocusInside, setIsFocusInside]);
  useEffect(function () {
    if (!open) setIsFocusInside(false);
  }, [open, setIsFocusInside]);

  // Set noScroll and activeTrap only when modal opens and cleanup on close
  useEffect(function () {
    if (open) {
      _noScroll["default"].on();
    } else {
      _noScroll["default"].off();
    }
    return function cleanup() {
      if (!open) _noScroll["default"].off();
    };
  }, [open]);
  return /*#__PURE__*/_react["default"].createElement(_styledDrawerDialogue.Dialog, {
    "aria-hidden": open ? undefined : true,
    "aria-labelledby": drawerHeadingId,
    "aria-modal": open,
    "data-testid": dataTestId,
    inert: open ? undefined : 'true',
    open: open,
    role: "dialog",
    ref: ref,
    slidePosition: slidePosition,
    tabIndex: open && !isFocusInside ? '0' : '-1',
    zIndex: zIndex,
    onBlur: handleBlur
  }, /*#__PURE__*/_react["default"].createElement(_styledDrawerDialogue.Content, {
    open: open,
    ref: drawerContentRef
  }, /*#__PURE__*/_react["default"].createElement(_drawerHeader["default"], {
    title: title,
    backCallback: function backCallback(event) {
      _backCallback(event, ref);
    },
    closeCallback: function closeCallback(event) {
      _closeCallback(event, ref);
      onClose();
    },
    drawerHeadingId: drawerHeadingId,
    hasBackButton: hasBackButton,
    hasDepth: isScrolled,
    srLabelBackButton: srLabelBackButton,
    srLabelCloseButton: srLabelCloseButton
  }), /*#__PURE__*/_react["default"].createElement(_styledDrawerDialogue.DrawerBody, {
    hasPromotionalArea: promotionalArea,
    onScroll: handleScroll,
    stickyDrawerHeight: stickyDrawerHeight
  }, promotionalArea && /*#__PURE__*/_react["default"].createElement(_styledDrawerDialogue.DrawerPromotionalArea, null, promotionalArea), children && /*#__PURE__*/_react["default"].createElement(_styledDrawerDialogue.DrawerBodyContent, {
    hasPromotionalArea: promotionalArea
  }, children)), /*#__PURE__*/_react["default"].createElement(_styledDrawerDialogue.StyledStickyDrawer, stickyDrawerProps, stickyDrawer.button)));
});
DrawerDialog.propTypes = propTypes;
DrawerDialog.defaultProps = defaultProps;
var _default = exports["default"] = DrawerDialog;